import { motion } from "framer-motion";
import { Overline } from "@/components/site/Reveal";

export const PageHero = ({ overline, title, subtitle, image }) => (
  <section data-testid="page-hero" className="relative pt-40 md:pt-48 pb-16 md:pb-24 overflow-hidden bg-ink grain">
    {image && (
      <div className="absolute inset-0 z-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/80 to-ink/40" />
      </div>
    )}
    <div className="relative z-10 max-w-container mx-auto px-6 md:px-12">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <Overline>{overline}</Overline>
      </motion.div>
      <h1 className="mt-6 font-display font-bold text-white text-5xl md:text-7xl tracking-tighter leading-[0.95] max-w-4xl">
        {title.map((line, i) => (
          <span key={i} className="block overflow-hidden">
            <motion.span
              className="block"
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.8, delay: 0.15 + i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </h1>
      {subtitle && (
        <motion.p
          className="mt-8 text-lg md:text-xl text-slatetxt max-w-2xl leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.7 }}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
